import { render, staticRenderFns } from "./DialogMethod.vue?vue&type=template&id=2238050c"
import script from "./DialogMethod.vue?vue&type=script&lang=js"
export * from "./DialogMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports